import {
  Button,
  Container,
  Divider,
  Heading,
  Icon,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { LucideFile, LucideHome, LucideNewspaper, LucideTwitter } from "lucide-react";
import { LucideChevronDown } from "lucide-react";

export default function NotFoundPage() {
  return (
    <Container maxW="container.sm" py={16}>
      <Stack spacing={12}>
        <VStack textAlign="center">
          <Text as="span" textTransform="uppercase" fontWeight="semibold">
            Error 404
          </Text>
          <Heading as="h1" size={{ base: "xs", md: "md" }}>
            This page does not exist
          </Heading>
          <Text fontSize="lg" color="subtle">
            Try checking the URL to make sure it is correct.
          </Text>
        </VStack>

        <Stack>
          <Heading as="h2" fontSize="sm">
            Popular Pages
          </Heading>
          <Stack divider={<Divider />}>
            {[
              {
                title: "Home",
                description: "Go back to the homepage",
                href: "https://chainpatrol.com",
                icon: LucideHome,
              },
              {
                title: "Documentation",
                description: "Learn how to integrate your wallet",
                href: "https://chainpatrol.com/docs",
                icon: LucideFile,
              },
              {
                title: "Blog",
                description: "Read our latest news and updates",
                href: "https://chainpatrol.com/blog",
                icon: LucideNewspaper,
              },
              {
                title: "Twitter",
                description: "Follow us on Twitter for updates",
                href: "https://x.com/chainpatrol",
                icon: LucideTwitter,
              },
            ].map((item) => (
              <Button
                key={item.title}
                as="a"
                href={item.href}
                variant="ghost"
                leftIcon={<Icon as={item.icon} boxSize={6} />}
                rightIcon={<Icon as={LucideChevronDown} />}
                iconSpacing={5}
                width="full"
                h="auto"
                py={3}
                px={5}>
                <Stack flex="1" textAlign="left" spacing={0}>
                  <Text as="h3" fontSize="md">
                    {item.title}
                  </Text>
                  <Text color="whiteAlpha.600">{item.description}</Text>
                </Stack>
              </Button>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
}
